import styled from 'styled-components';
import { HeImgix } from '../../../common/components/images/HeImgix';
import {
  FLEX_ROWS,
  FLEX_COL_TO_ROW,
  FLEX_ROW_TO_COL,
} from '../../../common/components/layout/FlexLayout';
import { ThemeColours, transparentThemeColour } from '../../../common/styles/ThemeColours';
import { Breakpoint, FontSize, FontWeight, FONT_STACK } from '../../../common/styles/constants';
import { propSwitch } from '../../../common/util/propSwitch';

export const SearchSpecialtySelectorWrapper = styled.div`
  position: relative;
`;

export const GPCardsContainer = styled.div`
  display: flex;
  height: 172px;
  justify-content: space-between;

  ${Breakpoint.SMALL} {
    height: 143px;
    margin-bottom: 20px;
  }
`;

export const SearchSpecialtyButtonContainer = styled.div<{ experiment?: boolean }>`
  ${props => (props.experiment ? FLEX_ROWS : FLEX_COL_TO_ROW(Breakpoint.SMALL))};
  display: ${props => (props.experiment ? 'flex' : 'inline-flex')};
  flex-wrap: wrap;
  gap: ${props => (props.experiment ? '20px' : '12px')};
  height: 100%;
  margin-bottom: 16px;
  overflow: hidden;
  padding-bottom: ${props => (props.experiment ? '0px' : '10px')};
  padding-left: ${props => (props.experiment ? '20px' : '0px')};
  width: ${props => (props.experiment ? 'calc(100% - 20px)' : '100%')};

  ${Breakpoint.SMALL} {
    border-radius: 8px;
    box-shadow: 0px 1px 2px ${transparentThemeColour('mono900', 0.9)};
    gap: 0px;
    padding-bottom: 0px;
    padding-left: 0px;
    width: 100%;
  }
`;

export const DesktopHideWrapper = styled.div`
  display: inherit;

  ${Breakpoint.SMALL} {
    display: none;
  }
`;

export const MobileHideWrapper = styled.div`
  display: none;

  ${Breakpoint.SMALL} {
    display: inherit;
  }
`;

export const SpecialtyIconWrapper = styled.div<{ experiment?: boolean }>`
  align-items: center;
  background-color: ${ThemeColours.primary300};
  border-radius: 100px;
  display: flex;
  height: ${props => (props.experiment ? '24px' : '25px')};
  justify-content: center;
  margin-right: 12px;
  padding: ${props => (props.experiment ? '0px' : '10px')};
  width: 25px;

  ${Breakpoint.SMALL} {
    height: 40px;
    margin-bottom: 10px;
    margin-right: 0;
    padding: 10px;
    width: 40px;
  }
`;

export const SpecialtyIcon = styled(HeImgix)<{ experiment?: boolean }>`
  height: ${props => (props.experiment ? '15px' : '24px')};

  ${Breakpoint.SMALL} {
    height: 30px;
  }
`;

export const StyledSpecialtyButton = styled.div<{
  active: boolean;
  experiment?: boolean;
}>`
  ${FLEX_ROW_TO_COL(Breakpoint.SMALL)}
  align-items: center;
  background-color: ${propSwitch('active', ThemeColours.primary500, ThemeColours.white)};
  border: ${props => (props.experiment ? '1px solid' : '1px solid')};
  border-color: ${props => (props.experiment ? ThemeColours.mono200 : 'transparent')};
  border-radius: ${props => (props.experiment ? '4px' : '8px')};
  box-shadow: ${props => (props.experiment ? 'none' : '0px 1px 2px rgb(7 35 38 / 10%)')};
  color: ${({ active }) => (active ? ThemeColours.white : ThemeColours.mono800)};
  cursor: pointer;
  flex: ${props => (props.experiment ? 'nowrap' : '1')};
  height: ${props => (props.experiment ? '40px' : 'auto')};
  padding: ${props => (props.experiment ? '0px 12px' : '10px')};
  text-align: center;
  transition: background-color 0.3s, color 0.3s, border 0.3s;

  ${Breakpoint.SMALL} {
    align-items: center;
    border: 1px solid transparent;
    border-radius: 0;
    box-shadow: none;
    flex: 1;
    height: auto;
    justify-content: flex-start;
    padding: 10px;
  }

  &:not(:last-child) {
    border-right: 1px solid;
    border-right-color: ${props =>
      props.experiment ? ThemeColours.mono200 : ThemeColours.mono100};

    ${Breakpoint.SMALL} {
      border-right-color: ${ThemeColours.mono100};
    }
  }

  &:first-child {
    border-bottom-left-radius: 8px;
    border-top-left-radius: 8px;
  }

  &:last-child {
    ${Breakpoint.SMALL} {
      border: 1px solid transparent;
      border-bottom-right-radius: 8px;
      border-top-right-radius: 8px;
    }
  }

  &:hover {
    border: 1px solid ${ThemeColours.primary300};
  }
`;

export const SpecialtyLabel = styled.p<{ hiddenMobile?: boolean; experiment?: boolean }>`
  ${FONT_STACK}
  font-size: ${FontSize.SMALL};
  font-weight: ${props => (props.experiment ? FontWeight.SEMI_BOLD : FontWeight.REGULAR)};
  margin: 0;
`;

export const SpecialtyLabelDesktop = styled(SpecialtyLabel)<{
  hiddenMobile?: boolean;
  experiment?: boolean;
}>`
  display: ${propSwitch('hiddenMobile', 'none', 'flex')};
  font-size: ${props => (props.experiment ? FontSize.SMALL : FontSize.SMALL)};

  ${Breakpoint.SMALL} {
    display: flex;
    font-size: ${FontSize.SMALL};
    margin: auto 0;
  }
`;

export const SpecialtyLabelMobile = styled(SpecialtyLabel)<{ experiment?: boolean }>`
  font-size: ${props => (props.experiment ? FontSize.SMALL : FontSize.SMALL)};
  ${Breakpoint.SMALL} {
    display: none;
  }
`;

export const Badge = styled.div`
  align-items: center;
  background-color: ${ThemeColours.accent400};
  border-radius: 16px;
  color: ${ThemeColours.white};
  display: flex;
  font-size: ${FontSize.SMALL};
  height: 32px;
  justify-content: center;
  margin-left: 18px;
  padding: 4px 8px;

  ${Breakpoint.SMALL} {
    display: none;
  }
`;
